var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2757 10.9417C21.7965 10.4208 21.7965 9.57499 21.2757 9.05416L15.9423 3.72082C15.4215 3.19999 14.5757 3.19999 14.0548 3.72082C13.534 4.24166 13.534 5.08749 14.0548 5.60832L17.1132 8.66666H8.33398C7.59648 8.66666 7.00065 9.26249 7.00065 9.99999C7.00065 10.7375 7.59648 11.3333 8.33398 11.3333H17.1132L14.0548 14.3917C13.534 14.9125 13.534 15.7583 14.0548 16.2792C14.5757 16.8 15.4215 16.8 15.9423 16.2792L21.2757 10.9458V10.9417ZM7.00065 3.33332C7.73815 3.33332 8.33398 2.73749 8.33398 1.99999C8.33398 1.26249 7.73815 0.666656 7.00065 0.666656H4.33398C2.12565 0.666656 0.333984 2.45832 0.333984 4.66666V15.3333C0.333984 17.5417 2.12565 19.3333 4.33398 19.3333H7.00065C7.73815 19.3333 8.33398 18.7375 8.33398 18C8.33398 17.2625 7.73815 16.6667 7.00065 16.6667H4.33398C3.59648 16.6667 3.00065 16.0708 3.00065 15.3333V4.66666C3.00065 3.92916 3.59648 3.33332 4.33398 3.33332H7.00065Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.58d9c04302bde16a545d5ab6ce4ac480.svg";
export { ForwardRef as ReactComponent };